//  @flow

import React from 'react';

type InfoCardProps = {
  title: string,
  text: string
};

const InfoCard = (props: InfoCardProps) => {
  const { title, text } = props;

  return (
    <div className="about-info-card">
      <div className="dash" />
      <p>{title}</p>
      <span>{text}</span>
    </div>
  );
};

export default InfoCard;



// WEBPACK FOOTER //
// ./src/Pages/AboutUs/InfoCard.js